export enum RequestState {
	IDLE,
	PENDING,
	SUCCESS,
	ERROR,
}

export enum SortOrder {
	ASC = "asc",
	DESC = "desc",
}

export enum RoundStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
}

export enum TournamentStatus {
	Scheduled = "scheduled",
	Playing = "playing",
	Complete = "complete",
}

export enum SocialNetwork {
	Facebook,
	Twitter,
	Mobile,
}

export enum SocialType {
	Facebook = "facebook",
	Twitter = "twitter",
	Whatsapp = "whatsapp",
}

export enum ShareType {
	General = "general",
	League = "league",
}

export enum Locale {
	EN_US = "en-US",
}

export enum Language {
	EN = "en",
}

export enum FavoriteTeam {
	Europe = "europe",
	Usa = "usa",
	RyderCup = "ryder_cup",
}

export enum PlayerStatus {
	Available = "available",
	Unavailable = "unavailable",
}

export enum TeamRegion {
	Europe = "europe",
	Usa = "usa",
}

export enum Gender {
	Male = "male",
	Female = "female",
	Other = "other",
	NotToSay = "not_to_say",
}

export enum ProjectName {
	Gamezone = "GAMEZONE",
	Pickem = "PICKEM",
	Fantasy = "FANTASY",
	Pinpoint = "PINPOINT",
}

export enum PlayedGames {
	Pickem = "pickem",
	Fantasy = "fantasy",
	Pinpoint = "pinpoint",
}

export enum ModalType {
	LOGIN,
	REGISTRATION,
	FORGOT_PASSWORD,
	FORGOT_PASSWORD_CONFIRM,
	RESET_PASSWORD,
	ERROR,
	CONFIRM,
	TUTORIAL,
	INFO,
	LEAGUE_JOINED,
	LEAGUE_REMOVE_USER,
	LEAGUE_LEAVE,
	LEAGUE_REMOVE,
	PASSWORD_CHANGED,
	ACCOUNT_UPDATED,
	SECOND_REGISTRATION,
	TEAM_SAVED,
	LOSE_PICKS,
	EMPTY_LINEUP,
	SKIP,
	WELCOME,
	PREDICT,
}

export enum LeaguePrivacy {
	PUBLIC = "public",
	PRIVATE = "private",
}

export enum LeagueType {
	REGULAR = "regular",
	OVERALL = "overall",
}

export enum LeagueStatus {
	COMPLETE = "complete",
	PLAYING = "playing",
	SCHEDULED = "scheduled",
}

export enum RoundType {
	LONGESTDRIVE = "longestDrive",
	NEARESTPIN = "nearestPin",
}
